import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import ".././StuStyles/StudentProfile.css";
import { TiArrowBack } from "react-icons/ti";
import { useNavigate, useLocation } from "react-router-dom";

import profilepic from "../../../assets/board3.jpg";
import idimg from "./../../../assets/img1.png";

import ApiService from "../../../nhrc_apis/ApiService";

const { AdminAPI } = ApiService;

const StudentregView = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const membershipId =
    location.state?.membershipId ||
    location.state?.id ||
    null;

  const [data, setData] = useState(null);
  const [member, setMember] = useState({});
  const [details, setDetails] = useState({});
  const [loading, setLoading] = useState(true);

  /* =========================
     FETCH STUDENT DATA
  ========================== */
  useEffect(() => {
    if (membershipId) {
      fetchStudent();
    } else {
      setLoading(false);
    }
  }, [membershipId]);

  const fetchStudent = async () => {
    try {
      const res = await AdminAPI.getMemberById(membershipId);

      console.log("FULL API RESPONSE =>", res.data);

      /*
        API FORMAT:
        {
          member: {},
          details: {}
        }
      */

      const responseData = res.data || {};

      const memberData = responseData.member || {};
      const detailsData = responseData.details || {};

      setMember(memberData);
      setDetails(detailsData);

      setData(responseData);

      console.log("MEMBER DATA =>", memberData);
      console.log("DETAILS DATA =>", detailsData);

    } catch (err) {
      console.error("API ERROR:", err);

      setData(null);
    } finally {
      setLoading(false);
    }
  };

  /* =========================
     IMAGE HANDLER
  ========================== */
  const getImage = (img, fallback) => {
    if (!img || img === "" || img === null) {
      return fallback;
    }

    // FULL URL
    if (typeof img === "string" && img.startsWith("http")) {
      return img;
    }

    // LOCAL SERVER FILE
    if (typeof img === "string") {
      return `https://nhrc.onrender.com/${img}`;
    }

    return fallback;
  };

  /* =========================
     PROFILE PIC
  ========================== */
  const profileImage = getImage(
    member.profile_pic,
    profilepic
  );

  /* =========================
     ID CARD IMAGE
  ========================== */
  const idCardFrontImage = getImage(
    details.id_front,
    idimg
  );

  /* =========================
     NO MEMBERSHIP ID
  ========================== */
  if (!membershipId) {
    return (
      <div className="container mt-5 text-center">

        <h4>No Student Data Found</h4>

        <button
          className="btn btn-primary mt-3"
          onClick={() => navigate(-1)}
        >
          Go Back
        </button>

      </div>
    );
  }

  /* =========================
     LOADING
  ========================== */
  if (loading) {
    return (
      <div className="container mt-5 text-center">
        <h5>Loading...</h5>
      </div>
    );
  }

  /* =========================
     NO DATA
  ========================== */
  if (!data) {
    return (
      <div className="container mt-5 text-center">

        <h4>No Details Found</h4>

        <button
          className="btn btn-primary mt-3"
          onClick={() => navigate(-1)}
        >
          Go Back
        </button>

      </div>
    );
  }

  return (
    <div className="container student-profile-container mt-5 mb-0">

      {/* ================= HEADER ================= */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4 className="fw-bold mt-3">
          STUDENT REGISTRATION
        </h4>
      </div>

      {/* ================= PERSONAL DETAILS ================= */}
      <div className="card p-3 mb-4">

        <h5 className="section-title text-center">
          Personal Details
        </h5>

        <button
          className="jobback"
          style={{ width: "80px" }}
          onClick={() => navigate(-1)}
        >
          <TiArrowBack />
          Back
        </button>

        <div className="row g-3 mt-2">

          {/* PROFILE PIC */}
          <div className="col-md-4">
            <label className="form-label">
              Profile Pic
            </label>

            <div>
              <img
                src={profileImage}
                alt="profile"
                className="profile-pic"
                onError={(e) => {
                  e.target.src = profilepic;
                }}
              />
            </div>
          </div>

          {/* FULL NAME */}
          <div className="col-md-4">
            <label className="form-label">
              Full Name
            </label>

            <input
              className="form-control"
              value={member.full_name || ""}
              readOnly
            />
          </div>

          {/* EMAIL */}
          <div className="col-md-4">
            <label className="form-label">
              Email
            </label>

            <input
              className="form-control"
              value={member.email || ""}
              readOnly
            />
          </div>

          {/* DOB */}
          <div className="col-md-4">
            <label className="form-label">
              Date Of Birth
            </label>

            <input
              className="form-control"
              value={member.dob || ""}
              readOnly
            />
          </div>

          {/* GENDER */}
          <div className="col-md-4">
            <label className="form-label">
              Gender
            </label>

            <input
              className="form-control"
              value={member.gender || ""}
              readOnly
            />
          </div>

          {/* STATE */}
          <div className="col-md-4">
            <label className="form-label">
              State
            </label>

            <input
              className="form-control"
              value={member.state || ""}
              readOnly
            />
          </div>

          {/* DISTRICT */}
          <div className="col-md-4">
            <label className="form-label">
              District
            </label>

            <input
              className="form-control"
              value={member.district || ""}
              readOnly
            />
          </div>

          {/* PINCODE */}
          <div className="col-md-4">
            <label className="form-label">
              Pincode
            </label>

            <input
              className="form-control"
              value={member.pincode || ""}
              readOnly
            />
          </div>

          {/* BLOOD GROUP */}
          <div className="col-md-4">
            <label className="form-label">
              Blood Group
            </label>

            <input
              className="form-control"
              value={member.blood_group || ""}
              readOnly
            />
          </div>

          {/* MOBILE */}
          <div className="col-md-4">
            <label className="form-label">
              Mobile Number
            </label>

            <input
              className="form-control"
              value={member.mobile || ""}
              readOnly
            />
          </div>

          {/* MEMBERSHIP ID */}
          <div className="col-md-4">
            <label className="form-label">
              Membership ID
            </label>

            <input
              className="form-control"
              value={member.membership_id || ""}
              readOnly
            />
          </div>

          {/* STATUS */}
          <div className="col-md-4">
            <label className="form-label">
              Status
            </label>

            <input
              className="form-control"
              value={member.status || ""}
              readOnly
            />
          </div>

        </div>
      </div>

      {/* ================= STUDENT DETAILS ================= */}
      <div className="card p-3 mb-4">

        <h5 className="section-title text-center">
          Student Details
        </h5>

        <div className="row g-3 mt-2">

          {/* UNIVERSITY NAME */}
          <div className="col-md-4">
            <label className="form-label">
              University Name
            </label>

            <input
              className="form-control"
              value={details.university_name || ""}
              readOnly
            />
          </div>

          {/* COLLEGE NAME */}
          <div className="col-md-4">
            <label className="form-label">
              College Name
            </label>

            <input
              className="form-control"
              value={details.college_name || ""}
              readOnly
            />
          </div>

          {/* COLLEGE CODE */}
          <div className="col-md-4">
            <label className="form-label">
              College Code
            </label>

            <input
              className="form-control"
              value={details.college_code || ""}
              readOnly
            />
          </div>

          {/* QUALIFICATION */}
          <div className="col-md-4">
            <label className="form-label">
              Qualification
            </label>

            <input
              className="form-control"
              value={details.qualification || ""}
              readOnly
            />
          </div>

          {/* DEPARTMENT */}
          <div className="col-md-4">
            <label className="form-label">
              Department
            </label>

            <input
              className="form-control"
              value={details.department || ""}
              readOnly
            />
          </div>

          {/* START YEAR END YEAR */}
          <div className="col-md-4">
            <label className="form-label">
              Starting year Ending year
            </label>

            <input
              className="form-control"
              value={
                details.start_year && details.end_year
                  ? `${details.start_year} TO ${details.end_year}`
                  : ""
              }
              readOnly
            />
          </div>

          {/* ID CARD PROOF */}
          <div className="col-md-4">
            <label className="form-label">
              ID Card Proof
            </label>

            <div>
              <img
                src={idCardFrontImage}
                alt="ID Card"
                className="id-proof-img"
                onError={(e) => {
                  e.target.src = idimg;
                }}
              />
            </div>
          </div>

          {/* LOCATION */}
          <div className="col-md-4">
            <label className="form-label">
              Location
            </label>

            <input
              className="form-control"
              value={details.location || ""}
              readOnly
            />
          </div>

          {/* EMAIL */}
          <div className="col-md-4">
            <label className="form-label">
              Student Email
            </label>

            <input
              className="form-control"
              value={details.email || ""}
              readOnly
            />
          </div>

        </div>
      </div>

      {/* ================= DEBUG RESPONSE ================= */}
      <div className="card p-3 mb-4">

        <h5 className="mb-3">
          Debug API Response
        </h5>

        <pre
          style={{
            fontSize: "12px",
            overflow: "auto",
          }}
        >
          {JSON.stringify(data, null, 2)}
        </pre>

      </div>

    </div>
  );
};

export default StudentregView;